module.exports = __webpack_public_path__ + "assets/img/busy_5.ad808bf7.png";